import { render, staticRenderFns } from "./DigitImageDisplay.vue?vue&type=template&id=0d9ac2de&"
import script from "./DigitImageDisplay.vue?vue&type=script&lang=js&"
export * from "./DigitImageDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports